package com.alpha.showcase.common.ai

internal actual suspend fun shareAiImage(name: String, bytes: ByteArray): Unit = error("AI sharing is unavailable on web")
